<template>
  <el-main class="common-main">
    <div class="container">
      <div class="pay-header">
        <div class="pay-intro">
          <div class="pay-intro-no">订单已生成，请尽快付款！订单号：{{ order.no }}</div>
          <div class="pay-intro-time">
            <span>请您在 </span>
            <timeDown :endTime="endTime" v-if="endTime" v-on:endDo="endDo"></timeDown>
            <span> 内完成支付，否则订单会被自动取消</span>
          </div>
        </div>
        <div class="pay-price">
          <span>应付金额：</span>
          <span class="pay-price-number">¥{{ order.total_amount }}</span>
        </div>
      </div>
      <div class="pay-type">
        <div class="pay-bank-box" v-if="order.payment_method === 'bank'">
          <div class="pay-bank">
            <img :src="path + bank.bank_logo" :alt="bank.bank_name" class="pay-bank-logo" v-if="bank.bank_logo">
            <div class="pay-bank-info">
              <div>开户名：{{ bank.account_name }}</div>
              <div>开户行：{{ bank.bank_name }}</div>
              <div>账户号：{{ bank.bank_card }}</div>
              <div class="pay-bank-intro">注：付款后请务必联系老师，确认此订单。确认后自动完成开课。</div>
            </div>
          </div>
          <div class="pay-bank-button">
            <el-button type="primary" @click="goOrder">完成</el-button>
          </div>
        </div>
        <div class="pay-bank-online" v-if="order.payment_method !== 'bank'">
          <div class="card-box">
            <div class="card-title">
              选择在线支付类型
            </div>
            <div class="card-body">
              <div class="pay-type-box">
                <div class="pay-type-item" v-for="(item, index) in payType" :key="index"
                     :class="[index === payTypeIndex ? 'current' : '']" @click="changeType(index)">
                  <img :src="item.src" :alt="item.name">
                </div>
              </div>
              <div class="pay-type-image" v-if="wxpayShow">
                <img :src="url + '/payment/' + id + '/wxqr'" alt="微信扫码支付" class="wxpay-image">
                <p class="pay-type-image-title">微信扫码支付二维码</p>
              </div>
              <div class="pay-bank-button">
                <el-button type="primary" @click="goPay">提交</el-button>
                <el-button type="success" @click="goOrder" v-if="wxpayShow">已完成付款</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
import {authRequest, request} from "@/utils/request";
import timeDown from '@/components/timeDown/timeDown'

const timeDate = require("@/utils/date.js");

export default {
  components: {
    timeDown
  },
  name: "pay",
  head: {
    title: "收银台"
  },
  data() {
    return {
      id: 0,
      order: '',
      endTime: '',
      bank: '',
      path: process.env.VUE_APP_FILE,
      url: process.env.VUE_APP_URL,
      payType: [{
        src: 'https://xcx.yxyuanxue.com/images/wechatpay.png',
        name: '微信支付'
      }, {
        src: 'https://xcx.yxyuanxue.com/images/alipay.png',
        name: '支付宝'
      }],
      payTypeIndex: '',
      wxpayShow: false
    }
  },
  created() {
    this.id = this.$route.params.id
    this.getOrder()
  },
  methods: {
    async getOrder() {
      try {
        let response = await authRequest('order/' + this.id, {
          method: 'GET'
        })
        this.order = response.data.data

        // 获取支付剩余时间
        this.getOrderTimer()

        if (this.order.payment_method === 'bank') {
          this.getBank()
        }
      } catch (e) {
        this.$router.replace({path: '/error/404'})
      }
    },
    async getOrderTimer() {
      try {
        let response = await authRequest('order/timer/' + this.id, {
          method: 'GET'
        })

        if (response.status === 205) {
          this.$message.success('订单已支付')
          this.$router.replace({path: '/user/order'})
          return false
        }

        this.endTime = timeDate.currentTime('str', response.data * 1000)
      } catch (e) {
        this.$router.replace({path: '/user/order'})
      }
    },
    endDo() {
      this.$message.error('订单已超时')
    },
    async getBank() {
      try {
        let response = await request('setting/bank', {
          method: 'GET'
        })
        this.bank = response.data
      } catch (e) {

      }
    },
    goOrder() {
      this.$router.push({path: '/user/order'})
    },
    changeType(index) {
      this.payTypeIndex = index
    },
    async goPay() {
      if (this.payTypeIndex === '') {
        this.$message.warning('请选择在线支付类型')
        return false
      }
      if (this.payTypeIndex === 0) {
        this.wxpayShow = true
        let checkSuccess = setInterval(async () => {
          try {
            let response = await authRequest('order/timer/' + this.id, {
              method: 'GET'
            })
            if (response.status === 205) {
              clearInterval(checkSuccess)
              this.$message.success('订单已支付')
              this.$router.replace({path: '/order/pay/success'})
              return false
            }
          } catch (e) {

          }
        }, 1000)
      }
      if (this.payTypeIndex === 1) {
        this.wxpayShow = false
        // this.$message.info('支付宝暂未开通，即将上线')
        // return false
        window.location.href = this.url + '/payment/' + this.id + '/alipay'
      }
    }
  }
}
</script>

<style scoped>
.pay-header {
  background-color: #ffffff;
  padding: 15px;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pay-intro-no {
  font-size: 15px;
}

.pay-intro-time {
  font-size: 13px;
}

.pay-price {
  font-size: 14px;
}

.pay-price-number {
  color: #f44848;
  font-size: 20px;
  font-weight: bold;
}

.pay-type {
  margin-top: 20px;
  background-color: #ffffff;
  border-radius: 5px;

}

.pay-bank-box {
  padding: 15px;
}

.pay-bank {
  display: flex;
  align-content: center;
  font-size: 16px;
}

.pay-bank-logo {
  width: 150px;
  margin-right: 30px;
}

.pay-bank-info {
  display: flex;
  align-content: center;
  flex-wrap: wrap;
}

.pay-bank-info div {
  width: 100%;
}

.pay-bank-intro {
  font-size: 12px;
  margin-top: 10px;
  color: red;
}

.pay-bank-button {
  margin-top: 30px;
  text-align: center;
}

.pay-type-box {
  display: flex;
}

.pay-type-item {
  width: 150px;
  height: 65px;
  display: flex;
  align-content: center;
  justify-content: center;
  border-radius: 5px;
  border: 1px solid #ddd;
  padding: 10px;
  margin-right: 20px;
  cursor: pointer;
}

.pay-type-item img {
  width: 100%;
}

.pay-type-item.current {
  border-color: #2aacb2;
}

.pay-type-image {
  display: flex;
  margin-top: 50px;
  justify-content: center;
  flex-wrap: wrap;
}

.pay-type-image-title {
  width: 100%;
  text-align: center;
  font-size: 16px;
}

.wxpay-image {
  box-shadow: 0 0px 10px rgba(0, 0, 0, .3);
}
</style>